<template>
    <div>
        <Header>
            <template v-slot:menu_center>
                <p class="menu_center_tex_l top_tit">HACCP STATION</p>
            </template>
        </Header>
        <ErrorPanel
                title="エラー"
                code=""
                message="ページが見つかりません"
                :button-path="{ name: 'top', params: { brandPath: brandPath } }"
                button-text="トップに戻る"
                :can-back="this.brandPath !== ''"
        />
    </div>
</template>

<script>
    import Header from '@/app/components/Header.vue'
    import ErrorPanel from '@/app/components/ErrorPanel.vue'
    export default {
        name: 'Error',
        components: {
            Header,
            ErrorPanel,
        },
        computed: {
            brandPath: function () {
                if (this.$store.getters['manager/exists'] && this.$store.getters['manager/authorityKbnName'] === 'system') {
                    return process.env.VUE_APP_ADMIN_BRAND_PATH
                }
                // storeにあるbrand情報, なければ空文字
                return this.$store.getters['brand/path']
            },
        },
        beforeDestroy: function () {
            this.$store.dispatch('error/clearError')
        }
    }
</script>
